/**
 * Format display months:
 * - All months: "毎月"
 * - Consecutive months: "1～3月"
 * - Mixed/Non-consecutive months: "1～3・11・12月" or "1・3・5・7・9・11月"
 *
 * Examples from spec:
 * - [1,2,3,11,12] → "1〜3・11・12月"
 * - [1,3,5,7,9,11] → "1・3・5・7・9・11月"
 * - [1,2,3,4,5,6,7,8,9,10,11,12] → "毎月"
 */
export const formatDisplayMonths = (months: number[]): string => {
  if (!months || months.length === 0) return "";

  // If all 12 months are selected, display "毎月"
  if (months.length === 12) {
    return "毎月";
  }

  const sortedMonths = [...months].sort((a, b) => a - b);

  const groups: number[][] = [];
  let currentGroup = [sortedMonths[0]];

  for (let i = 1; i < sortedMonths.length; i++) {
    if (sortedMonths[i] === sortedMonths[i - 1] + 1) {
      currentGroup.push(sortedMonths[i]);
    } else {
      groups.push(currentGroup);
      currentGroup = [sortedMonths[i]];
    }
  }
  groups.push(currentGroup);

  const parts: string[] = [];

  for (const group of groups) {
    if (group.length === 1) {
      parts.push(group[0].toString());
    } else if (group.length === 2) {
      parts.push(group[0].toString());
      parts.push(group[1].toString());
    } else {
      // 3 or more consecutive months use ～
      parts.push(`${group[0]}～${group[group.length - 1]}`);
    }
  }

  // Join with ・ and add single 月 at the end
  return parts.join("・") + "月";
};
